// @flow
import type { RaceCardBettingInterest } from "@tvg/types/Race";

export const getRunner = (
  biRunner: ?RaceCardBettingInterest,
  runnerName: string
) =>
  biRunner &&
  biRunner.runners.find(
    (runner) => runner.horseName.toLowerCase() === runnerName.toLowerCase()
  );

const getRaceAtiveRunnerBI = (
  runners: RaceCardBettingInterest[],
  activeRunner: string
) => runners.find((biRunner) => getRunner(biRunner, activeRunner));

export default getRaceAtiveRunnerBI;
